import React from 'react';

import icon1 from '../assets/img/icon-1.png';
import icon2 from '../assets/img/icon-2.png';
import services from '../assets/img/services.png';


const OurServices = () => {
    return (
        <section className="services-sec">
            <div className="container c_container">
                <div className="row align-items-center">
                    <div className="col-lg-5 order-1 order-lg-0">
                        <div className="services-left">
                            <h6 className="small-heading" data-aos="fade-up">Our Services</h6>
                            <h3 className="heading-gradient" data-aos="fade-up">Start Preparing for Your Next test!</h3>
                            <p className="para-16" data-aos="fade-up">A differentiator for nursing homes, primary centres, events companies and other healthcare facilities</p>
                            <a href="#" className="small-heading" data-aos="fade-up">Read More</a>
                            <div className="services-list" data-aos="fade-up">
                                <img src={icon1} alt="" />
                                <h6>On-Demand X-ray Service</h6>
                                <p>Working with Nursing Homes and Homecare providers, we arrive on-site and perform an X-ray examination of a client in their own room or a designated room.</p>
                            </div>
                            <div className="services-list" data-aos="fade-up">
                                <img src={icon2} alt="" />
                                <h6>On-Site X-ray Department</h6>
                                <p>Working with Nursing Homes and Homecare providers, we arrive on-site and perform an X-ray examination of a client in their own room or a designated room.</p>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 order-0 order-lg-0">
                        <div className="services-right" data-aos="fade-up">
                            <img src={services} alt="" className="w-100" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default OurServices;